import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {useScrollTrigger} from "@mui/material"
import {breakpoints} from "@next/themes"
import {checkIfMerchandisedUrl} from "@next/utils"
import {STICKY_HEADER_SCROLL_TRIGGER} from "../../config/constants"
import connect from "./connect"
import {Breadcrumbs} from "../../models/SearchState"
import {httpUrlTrimmer} from "../../utils/httpUrlTrimmer"
import useMediaQuery from "../../hooks/useMediaQuery"

export interface MobileHeaderProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    breadcrumbs: Breadcrumbs
    url: string
}

const MobileHeader = memo(({templating, breadcrumbs, url}: MobileHeaderProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    const sticky = useScrollTrigger({threshold: STICKY_HEADER_SCROLL_TRIGGER})
    const isMerchandisedUrl = checkIfMerchandisedUrl(httpUrlTrimmer(url))
    const inPageFiltersVisible = useMediaQuery(`(max-width:${breakpoints.values.lg}px)`)

    return (
        <ComponentName
            isMerchandisedUrl={isMerchandisedUrl}
            sticky={sticky}
            breadcrumbsEnabled={breadcrumbs.enabled}
            inPageFiltersVisible={inPageFiltersVisible}
        />
    )
})
MobileHeader.displayName = "MobileHeader"

export default connect(MobileHeader)
